import { render, staticRenderFns } from "./DonutChart09.vue?vue&type=template&id=5204e945&scoped=true"
import script from "./DonutChart09.vue?vue&type=script&lang=js"
export * from "./DonutChart09.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5204e945",
  null
  
)

export default component.exports